import React from 'react';
import { observer } from 'mobx-react';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';
import AddDeviceInDbTableComponent from './Add-device-in-db-table.component';
import useAddDeviceInDbTable from './useAddDeviceInDbTable';

const Container: React.FC<ICloseEvent> = ({ onClose }: ICloseEvent) => {
    const { devices, lang, state, handlers } = useAddDeviceInDbTable(onClose);

    return (
        <>
            <AddDeviceInDbTableComponent
                loading={state.loading}
                lang={lang.lang}
                page={state.page}
                limit={state.limit}
                rows={state.rows}
                columns={state.columns}
                uploadError={state.uploadError}
                errorMap={state.errorMap}
                imeiNotExistError={devices.imeiNotExistError}
                noRightsError={devices.noRightsError}
                onPageChange={handlers.handlePageChange}
                onCancelClick={handlers.handleCancelClick}
                onAddClick={handlers.handleAddClick}
                onCellEdit={handlers.handleCellEdit}
                onCellEditStart={handlers.handleCellEditStart}
                onCellEditStop={handlers.handleCellEditStop}
                onKeyDown={handlers.handleKeyDown}
                onBtnKeyDown={handlers.handleBtnKeyDown}
                onLimitChange={handlers.handeLimitChange}
                onClose={onClose}
            />
        </>
    );
};

const AddDeviceInDbTableContainer = observer(Container);

export default AddDeviceInDbTableContainer;
